import React from 'react';

interface StrategyFloatingProgressProps {
  progress: number;
  hasUnsavedChanges: boolean;
  areCriteriaComponentsConfigured: boolean;
}

const StrategyFloatingProgress: React.FC<StrategyFloatingProgressProps> = ({
  progress,
  hasUnsavedChanges,
  areCriteriaComponentsConfigured,
}) => {
  return (
    <div
      className={`fixed bottom-5 left-16 bg-white rounded-lg shadow-lg border p-4 z-50 min-w-48 transition-all duration-300 ${
        hasUnsavedChanges ? 'border-amber-300 bg-amber-50' : 'border-slate-200'
      }`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-slate-700">Progress</span>
        <span className="text-xs font-semibold text-sky-600">{progress}%</span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-2">
        <div
          className="bg-sky-600 h-2 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="mt-2 flex items-center justify-between gap-2">
        <div className="text-xs text-slate-500">
          {progress === 100 && areCriteriaComponentsConfigured
            ? 'Ready to save!'
            : progress === 100 && !areCriteriaComponentsConfigured
            ? 'Configure criteria components'
            : `${5 - Math.floor(progress / 20)} fields remaining`}
        </div>
        {hasUnsavedChanges && (
          <div className="flex items-center gap-1 text-amber-600">
            <div className="w-1.5 h-1.5 bg-amber-400 rounded-full animate-pulse"></div>
            <span className="text-xs font-medium">Unsaved</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StrategyFloatingProgress;
